import { Meta, Title } from "@solidjs/meta";
import { ClosingCTA } from "~/components/marketing/ClosingCTA";
import { PageHero } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";
import {
  AfterMeetingGroup,
  AutomationGroup,
  AutoTagsGroup,
  IntegrationsGroup,
  LiveSessionGroup,
  MemoryGroup,
  ProactiveGroup,
  SpeakersGroup,
  TrustGroup,
} from "./internal/Groups";
import { SectionNav } from "./internal/SectionNav";

/** The long version of the homepage: every shipped capability, one anchored group each. */
export const FeaturesPage = () => {
  const { t } = useI18n();
  return (
    <>
      <Title>{t("marketing.features.meta_title")}</Title>
      <Meta name="description" content={t("marketing.features.hero.sub")} />
      <PageHero
        eyebrow={t("marketing.nav.features")}
        title={t("marketing.features.hero.title")}
        sub={t("marketing.features.hero.sub")}
        from="features hero"
      />
      <SectionNav />
      <LiveSessionGroup />
      <ProactiveGroup />
      <AutoTagsGroup />
      <SpeakersGroup />
      <AfterMeetingGroup />
      <IntegrationsGroup />
      <MemoryGroup />
      <AutomationGroup />
      <TrustGroup />
      <ClosingCTA id="features-closing" title={t("marketing.features.closing")} from="features closing" />
    </>
  );
};
